import React from "react";

const Support: React.FC = () => {
  // Track page view (disabled for showcase)
  React.useEffect(() => {
    // Analytics removed for showcase site
  }, []);
  return (
    <div className="min-h-screen bg-gray-50 p-6 pb-32 md:pb-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">Support</h1>
            <p className="text-lg text-gray-600 leading-relaxed">
              If you're experiencing issues with PixelMaker please check to see
              if your question is answered in the FAQs below. If you don't find
              an answer or have any feedback, please contact us at{" "}
              <a
                href="mailto:hello@pixelmaker.ai"
                className="text-blue-600 hover:text-blue-700 font-medium"
              >
                hello@pixelmaker.ai
              </a>{" "}
              from the email you used for your account. We'll try to get back to
              you within 24 hours.
            </p>
          </div>

          {/* FAQs Section */}
          <div>
            <h2 className="text-xl font-semibold text-gray-900 mb-6">
              Frequently Asked Questions
            </h2>
            <div className="space-y-6">
              <div className="border-b border-gray-100 pb-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  How long does it take to generate a video?
                </h3>
                <p className="text-gray-600">
                  Video generation typically takes 2-3 minutes depending on the
                  complexity of your prompt and the selected model quality.
                </p>
              </div>

              <div className="border-b border-gray-100 pb-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  What video formats are supported?
                </h3>
                <p className="text-gray-600">
                  All generated videos are provided in MP4 format at 16:9 aspect
                  ratio, optimized for sharing across social media platforms.
                </p>
              </div>

              <div className="border-b border-gray-100 pb-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  Can I download my generated videos?
                </h3>
                <p className="text-gray-600">
                  Yes! You can download all your generated videos directly to
                  your device from both the video preview page and your "My
                  Videos" library.
                </p>
              </div>

              <div className="border-b border-gray-100 pb-6">
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  How many videos can I generate?
                </h3>
                <p className="text-gray-600">
                  The number of videos you can generate depends on your
                  subscription plan. Check your account dashboard to see your
                  current usage and limits.
                </p>
              </div>

              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  What should I do if my video generation fails?
                </h3>
                <p className="text-gray-600">
                  If your video generation fails, please try again with a
                  simplified prompt. If the issue persists, contact our support
                  team with details about your prompt and any error messages you
                  received.
                </p>
              </div>
            </div>
          </div>

          {/* Contact Section */}
          <div className="mt-12 bg-blue-50 border border-blue-200 rounded-lg p-6">
            <div className="flex items-center mb-4">
              <svg
                className="w-6 h-6 text-blue-600 mr-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              <h3 className="text-lg font-semibold text-blue-900">
                Need More Help?
              </h3>
            </div>
            <p className="text-blue-800">
              Still have questions? Our support team is here to help! Email us
              at{" "}
              <a
                href="mailto:hello@pixelmaker.ai"
                className="font-semibold underline hover:no-underline"
              >
                hello@pixelmaker.ai
              </a>{" "}
              and we'll get back to you as soon as possible.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
